
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class BurgerBtn extends Vue {
  @Prop(Boolean) readonly isActive!: boolean;
}
